import { SSRProvider } from "react-bootstrap";
import { Roboto } from "next/font/google";
import { PrismicProvider } from "@prismicio/react";
import Link from "next/link";
import { linkResolver } from "../../prismicio";
import Script from "next/script";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import "@/styles/bootstrap/index.scss";
import "../styles/globals.scss";
import CfTurnstile from "@/components/CfTurnstile";

const fontPrimary = Roboto({
  subsets: ["latin"],
  variable: "--theme-primary-font",
  weight: ["300", "400", "500", "700"],
});

export default function App({ Component, pageProps }) {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${fontPrimary.style.fontFamily};
        }
      `}</style>
      <Script
        strategy={"afterInteractive"}
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){
              w[l] = w[l] || []; w[l].push({
                'gtm.start':
    new Date().getTime(), event : 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
              'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })
    (window, document, 'script', 'dataLayer', 'GTM-TQ8JDGF');
              `,
        }}
      />
      <CfTurnstile />
      <PrismicProvider
        linkResolver={linkResolver}
        internalLinkComponent={(props) => <Link {...props} />}
      >
        {process.env.NODE_ENV !== "production" ? (
          <SSRProvider>
            <div className={fontPrimary.className}>
              <Component {...pageProps} />
            </div>
          </SSRProvider>
        ) : (
          <SSRProvider>
            <div className={fontPrimary.className}>
              <Component {...pageProps} />
            </div>
          </SSRProvider>
        )}
      </PrismicProvider>
    </>
  );
}
